import React from 'react';
import Grid from '@mui/material/Grid';

import {ContentHierarchyIcon} from './ContentHierarchyIcon';

export const HierarchyNodeDragPreview = (props) => {

    const item = props.monitorProps.item;

    const dragPreviewStyle = {
        alignItems: 'center',
        backgroundColor: '#1967d2',
        borderRadius: '0.25rem',
        boxShadow: '0 0.75rem 1.5rem -0.375rem rgba(0, 0, 0, .25), 0 0 0 0.063rem rgba(0, 0, 0, .08)',
        color: '#fff',
        display: 'inlineGrid',
        fontSize: '0.875rem',
        gap: '0.5rem',
        gridTemplateColumns: 'auto auto',
        padding: '0.25rem 0.5rem',
        pointerEvents: 'none',
        width: 'max-content'
    }

    return (
      <Grid container sx={dragPreviewStyle}>
          <Grid display='flex' alignItems='center'>
              <ContentHierarchyIcon nodeType={item.type}/>
          </Grid>
          <Grid display='flex' alignItems='center'>{item.text}</Grid>
      </Grid>
    );
};
